(function() {
  'use strict';

  function TrackingBarResource($resource, URL, PATH) {
    return $resource(URL + PATH, {}, {
      getProgresso: {
        method: 'GET',
        url: URL + PATH + '/items/:idRastreamento/tracking',
        params: {
          idRastreamento: '@idRastreamento'
        }
      }
    });
  };

  angular
    .module('mandaeApp')
    .factory('TrackingBarResource', TrackingBarResource);

}());
